








import {Component, Prop, Vue} from "vue-property-decorator";
import {Complaint} from "@/interfaces/entity";
import {ComplaintStore} from "@/modules/complaint/store";
    @Component({
        name: "ComplaintTableAction"
    })
    export default class extends Vue{
        @Prop({required: true, type: Number})
        readonly complaintId!: number;

        get complaint(): Complaint {
            return ComplaintStore.data[this.complaintId];
        }

        set complaint(value: Complaint){
            ComplaintStore.data[this.complaintId] = value;
        }


    }
